import { render, staticRenderFns } from "./CartCollapsible.vue?vue&type=template&id=64dcd584&scoped=true&"
import script from "./CartCollapsible.vue?vue&type=script&lang=js&"
export * from "./CartCollapsible.vue?vue&type=script&lang=js&"
import style0 from "./CartCollapsible.vue?vue&type=style&index=0&id=64dcd584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dcd584",
  null
  
)

export default component.exports